<template>
  <div class="main">
    <div class="content">
      <div class="title" @click="setTitle">
        <span>{{ $t('doc.title') }}</span>
        <span style="color: #0077ff">{{ crumbsText }}</span>
      </div>
      <div v-if="!componentId" style="margin-top: 10px;">
        <div v-for="menu in list" :key="menu.id" class="menuTitle">
          <div class="menu" @click="changeOpen(menu)">
            <span style="margin-right: 5px;font-weight: bold;">·</span>
            <span @click="menu.url ? setComponent(menu.url) : ''">{{
              menu.title
            }}</span>
            <!-- v-if="menu.children.length" -->

            <div
              v-if="menu.children.length"
              class="arrow el-icon-caret-top"
              :style="{
                transform: menu.isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
              }"
            ></div>
          </div>
          <div
            v-if="menu.children.length"
            class="list"
            :class="{ expanded: menu.isOpen, expander: !menu.isOpen }"
          >
            <div
              v-for="list in menu.children"
              :key="list.url"
              class="menu"
              style="font-size: 14px"
              @click="setComponent(list.url)"
            >
              <span>{{ list.id }}</span>
              <span>{{ list.title }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 暂时先不缓存组件 -->
      <!-- <keep-alive> -->
      <component :is="componentId"></component>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
import introduction from "./component/introduction.vue"; // 简介
import codeC from "./component/code.vue"; // 状态码
import tokenC from "./component/token.vue"; // 生成access Token
import infoSearch from "./component/infoSearch.vue"; // 摄像头信息查询
import videoStreaming from "./component/videoStreaming.vue"; // 摄获取像头视频流
export default {
  name: "OpenWebDocument",
  components: {
    introduction,
    codeC,
    tokenC,
    infoSearch,
    videoStreaming,
  },
  data() {
    return {
      componentId: "",
      crumbsKey: "",
      apiExpanded: true,
    };
  },
  computed: {
    // list 转 computed：菜单标题随语言热切换
    list() {
      return [
        { id: "intro", title: this.$t("doc.intro_title"), children: [], url: "introduction" },
        {
          id: "api",
          title: this.$t("doc.related_api"),
          isOpen: this.apiExpanded,
          children: [
            { id: "2.1", title: this.$t("doc.gen_token"), url: "tokenC" },
            { id: "2.2", title: this.$t("doc.camera_query"), url: "infoSearch" },
            { id: "2.3", title: this.$t("doc.get_stream"), url: "videoStreaming" },
          ],
        },
        { id: "codes", title: this.$t("doc.status_code"), children: [], url: "codeC" }
      ];
    },
    crumbsText() {
      return this.crumbsKey ? "/" + this.$t(this.crumbsKey) : "";
    },
  },

  mounted() {},

  methods: {
    changeOpen(row) {
      if (row.id === "api") this.apiExpanded = !this.apiExpanded;
    },
    setTitle() {
      this.componentId = "";
      this.crumbsKey = "";
    },
    // 设置组件
    setComponent(id) {
      this.componentId = id;
      switch (this.componentId) {
        case "introduction":
          this.crumbsKey = "doc.intro_title";
          break;
        case "codeC":
          this.crumbsKey = "doc.status_code_title";
          break;
        case "tokenC":
          this.crumbsKey = "doc.gen_token_title";
          break;
        case "infoSearch":
          this.crumbsKey = "doc.camera_query_title";
          break;
        case "videoStreaming":
          this.crumbsKey = "doc.get_stream_title";
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  height: 100%;
  padding: 0 10px;
  // width: 100%;
  background-color: #ecf0f3;
  .content {
    height: calc(100% - 20px);
    background-color: #fff;
    overflow: auto;
    // overflow-y: scroll;
    // overflow-x: hidden;
    padding: 10px;
    .title {
      font-size: 15px;
      padding: 8px 0 18px;
      border-bottom: 1px solid #ebeef5;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .menuTitle {
      // display: flex;
      // align-items: center;
      // justify-content: center;
      .menu:hover {
        cursor: pointer;
        color: #0077ff;
      }
      .menu {
        margin: 0 0 10px 10px;
        .arrow {
          // max-height: 0;
          transition: 500ms max-height ease;
        }
      }
      .list {
        // max-height: 0px;
        overflow: hidden;
        // transform: translateX(20px);
        margin-left: 43px;
      }
      .expander {
        max-height: 0;
        transition: max-height 0.2s ease;
        overflow: hidden;
      }
      .expanded {
        max-height: 1000px; /* 假定的足够大的值 */
        transition: max-height 1s ease;
      }
    }
  }
}
</style>